var _defs, _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _circle, _path53, _path54;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPharmacy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 509.83 377.93",
    id: "scientist",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 76.01,
    x2: 76.57,
    y1: 141.42,
    y2: 341.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 75.82,
    x2: 83.42,
    y1: 258.47,
    y2: 641.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 235.53,
    x2: 244.92,
    y1: 45.45,
    y2: 76.61,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 236.98,
    x2: 238.11,
    y1: 67.23,
    y2: 44.42,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 239.76,
    x2: 122.35,
    y1: 276.13,
    y2: 213.62,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 264.25,
    x2: 319.16,
    y1: 184.98,
    y2: -112.34,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: -289.74,
    x2: 1056.68,
    y1: 283.92,
    y2: 253.51,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 251.91,
    x2: 84.38,
    y1: 342.56,
    y2: 29.75,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 225.19,
    x2: 569.82,
    y1: 330.68,
    y2: 562.12,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 402.78,
    x2: 417.98,
    y1: 402.06,
    y2: 402.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecc4d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#efd4d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2eac9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 459.91,
    x2: 475.28,
    y1: 403.86,
    y2: 403.86,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 408.61,
    x2: 440.15,
    y1: 340.3,
    y2: 345.18,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 413.25,
    x2: 439.88,
    y1: 353.36,
    y2: 353.36,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 438.52,
    x2: 477.64,
    y1: 344.01,
    y2: 339.74,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 391.22,
    x2: 391.03,
    y1: 228.73,
    y2: 205.65,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 364.02,
    x2: 325.3,
    y1: 208.43,
    y2: 220.26,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 392.64,
    x2: 485.93,
    y1: 218.75,
    y2: 276.75,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 446.48,
    x2: 477.97,
    y1: 250.04,
    y2: 247.75,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 405.99,
    x2: 443.04,
    y1: 240.63,
    y2: 242.62,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 408.77,
    x2: 495.68,
    y1: 335.33,
    y2: 151.56,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 418.61,
    x2: 426.97,
    y1: 160.57,
    y2: 160.57,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 431.51,
    x2: 440.45,
    y1: 175.23,
    y2: 188.33,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 407.78,
    x2: 426.92,
    y1: 145.86,
    y2: 166.54,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 329.96,
    x2: 355.33,
    y1: 208.6,
    y2: 208.6,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 413.27,
    x2: 447.93,
    y1: 274.19,
    y2: 274.19,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 455.74,
    x2: 469.54,
    y1: 233.57,
    y2: 229.06,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 430.66,
    x2: 447.18,
    y1: 214.17,
    y2: 218.7,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 438.61,
    x2: 452.85,
    y1: 192.47,
    y2: 192.47,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 418.28,
    x2: 429.72,
    y1: 196.16,
    y2: 196.16,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 455.08,
    x2: 471.08,
    y1: 349.69,
    y2: 349.69,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 355.01,
    x2: 355.13,
    y1: 210.63,
    y2: 210.63,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 73.69,
    x2: 44.13,
    y1: 308.18,
    y2: 308.46,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 76.07,
    x2: 75.7,
    y1: 206.51,
    y2: 187.37,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 180.5,
    x2: 261.58,
    y1: 166.02,
    y2: 492.06,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 143.47,
    x2: 191.9,
    y1: 227.54,
    y2: 379.58,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 477.85,
    x2: 433.92,
    y1: 252.19,
    y2: 247.97,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 432.5,
    x2: 434.5,
    y1: 158.37,
    y2: 158.75,
    xlinkHref: "#c"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M509.76 274.19c-2.43 25 2.13 83.75-41.71 122.87-29.21 26.06-79.9 43.4-168.44 36.25-221.45-17.88-241.41 31.38-270.3-78.87 0 0-1.13-47.61-13.52-59.43S.42 244.19.42 244.19s-3.89-55.82 55.3-86.12 89.59 15.71 117.75 6.78 12.79-51.73 66.09-72 79.87-12.39 105.44 0 68.34 20.91 93.13 8.2 64 5.18 56.82 49 18.87 82.48 14.81 124.14Z",
    opacity: 0.25,
    transform: "translate(-.37 -57)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M509.76 274.19c-2.43 25 2.13 83.75-41.71 122.87-21.89 19.54-55.87 34.17-108.81 37.27a431.37 431.37 0 0 1-59.63-1c-207.22-16.73-238 25.32-264.79-59.53-1.82-5.8-3.65-12.27-5.51-19.36 0 0-1.13-47.61-13.52-59.43S.42 244.19.42 244.19s-3.89-55.82 55.3-86.12 89.59 15.71 117.75 6.78 12.79-51.73 66.09-72 79.87-12.39 105.44 0 68.34 20.91 93.13 8.2 64 5.18 56.82 49 18.87 82.48 14.81 124.14Z",
    opacity: 0.25,
    transform: "translate(-.37 -57)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M370.14 380c-.47 20.28-5.37 39.18-10.9 54.29a431.37 431.37 0 0 1-59.63-1c-207.22-16.73-238 25.32-264.79-59.53l41-51.18s147.08-110 319.26-94.4S371.26 331.61 370.14 380Z",
    opacity: 0.42,
    transform: "translate(-.37 -57)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "m469.43 394-1.38 3.05c-29.21 26.06-79.9 43.4-168.44 36.25-221.45-17.87-241.41 31.39-270.3-78.86 0 0 17.63-69.22 16.77-135.14l60.74 34.23s-.3 133.06 10.86 144.43 31.31 24.36 31.8-7.48 106.57-161.74 150.83-112.71 33.41 75.84 35.29 91.87-3.8 45 19.73 45.71 55.93-2.88 55.93-2.88Z",
    opacity: 0.25,
    transform: "translate(-.37 -57)",
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M106.45 143.46v195a30.37 30.37 0 1 1-60.74 0v-195Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M106.82 200.46v195a30.37 30.37 0 1 1-60.74 0v-195Z",
    transform: "translate(-.37 -57)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M98.56 196.53v139.63c0 11.89-9.32 21.94-21.2 22.27a21.82 21.82 0 0 1-22.43-21.81V196.53l6.7 4.18a29.83 29.83 0 0 0 36-3.35Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M98.93 253.53v139.63c0 11.89-9.32 21.94-21.2 22.27a21.82 21.82 0 0 1-22.43-21.81V253.53l6.7 4.18a29.83 29.83 0 0 0 36-3.35Z",
    transform: "translate(-.37 -57)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 83.79,
    height: 17.17,
    x: 195.8,
    y: 44.06,
    fill: "#68e1fd",
    rx: 8.59
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 83.79,
    height: 17.17,
    x: 195.8,
    y: 44.06,
    fill: "url(#d)",
    rx: 8.59
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 83.79,
    height: 17.17,
    x: 195.8,
    y: 44.06,
    fill: "url(#e)",
    rx: 8.59
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M344.2 269.8a106.51 106.51 0 0 1-107.27 106.51c-58.8-.42-106.45-49.05-105.73-107.84a106.51 106.51 0 0 1 62.63-95.75 26.23 26.23 0 0 0 15.43-23.89V61.22h56.93v87.63a26.26 26.26 0 0 0 15.44 23.91 106.52 106.52 0 0 1 62.57 97.04Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M344.57 326.8A106.51 106.51 0 0 1 237.3 433.31c-58.8-.42-106.45-49.05-105.73-107.84a106.51 106.51 0 0 1 62.63-95.75 26.23 26.23 0 0 0 15.43-23.89v-87.61h56.93v87.63A26.26 26.26 0 0 0 282 229.76a106.52 106.52 0 0 1 62.57 97.04Z",
    transform: "translate(-.37 -57)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M344.57 326.8A106.51 106.51 0 0 1 237.3 433.31c-58.8-.42-106.45-49.05-105.73-107.84a106.51 106.51 0 0 1 62.63-95.75 26.23 26.23 0 0 0 15.43-23.89v-87.61h56.93v87.63A26.26 26.26 0 0 0 282 229.76a106.52 106.52 0 0 1 62.57 97.04Z",
    transform: "translate(-.37 -57)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M338.34 327a99.21 99.21 0 0 1-99.92 99.21c-54.77-.39-99.15-45.69-98.48-100.45a99.22 99.22 0 0 1 58.34-89.18c8.74-4 18.5-12.65 18.5-22.25v-96.1h42.7v96.12c0 9.62 11.85 18.3 20.6 22.27A99.21 99.21 0 0 1 338.34 327Z",
    transform: "translate(-.37 -57)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M181.31 268.61s-9.6-6.76-32.2-2.63c0 0-2.34-13.86 18.68-15.94s66.77 5.8 86.51-6.21 54.52-21 70.17 6.21c0 0-34.67 5-50.06 18.57s-67.56 15.05-93.1 0Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M181.68 325.61s-9.6-6.76-32.2-2.63c0 0-2.34-13.86 18.68-15.94s66.77 5.8 86.51-6.21 54.52-21 70.17 6.21c0 0-34.67 5-50.06 18.57s-67.56 15.05-93.1 0Z",
    transform: "translate(-.37 -57)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M328.42 269.8a89.66 89.66 0 1 1-179.31 0c0-49.51 60 29.85 94.09-6.05 32.35-34.06 85.22-43.46 85.22 6.05Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M328.79 326.8a89.66 89.66 0 1 1-179.31 0c0-49.51 60 29.85 94.09-6.05 32.35-34.06 85.22-43.46 85.22 6.05Z",
    transform: "translate(-.37 -57)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#25233a",
    d: "M461.9 352.31s-5.13 10.32-4.85 12.63 5.08 2.76 9.72 0 8.14-10.37 8.14-10.37l1.15 5h2.25l-3.4-12.47s-9.56 3.9-13.01 5.21ZM416.96 348.55a9.5 9.5 0 0 1 .95 4.05c-.14 1.83-.95 8.31-.95 8.31h-1.86v-3.66s-5.35 5.21-8.45 5.91-10.56 3-12.67 1 9.52-11.6 9.52-11.6Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M405.33 408.19c-1.25 1.15-3.11 2.54-2.38 4.07a2.53 2.53 0 0 0 1.77 1.21c2.18.51 4.44-.25 6.54-1a11.52 11.52 0 0 0 3.48-1.71 7.81 7.81 0 0 0 2.59-5.21c.23-2 .85-6.46.58-8.43-.56-3.94-4.26-9.63-7-4.75-2.16 4.02-1.84 12.39-5.58 15.82Z",
    transform: "translate(-.37 -57)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M463.45 393.58a.56.56 0 0 1 .75.35l-1.2.07c-1.24 1.64-.19 3.93 0 6 .72 6.54-3.49 14-3.15 14.36a10.73 10.73 0 0 0 2.7.91c4.16 1.1 9.77-5.86 12-9.53a3.64 3.64 0 0 0 .63-1.6 3.94 3.94 0 0 0-.6-2l-2.48-4.9c-1.18-2.32-2.93-5-5.53-4.84-1.99.14-1.99-.58-3.12 1.18Z",
    transform: "translate(-.37 -57)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M406.33 267.38a83.76 83.76 0 0 0-3.76 20.62c-.27 7.54.95 15 2.16 22.29l3 18.05c.67 4-.78 8.85 1.06 11.85s7.34 3.59 9.28.76c-.22-13.63-.5-21.88.55-35.41.75-9.66 4-20.69 8.37-27.53 3-4.64 13.84-22.49 16.76-27.2s2.44-6.84 1.72-13.35c-1.41-12.73-19.23-8.94-25.25-2.63-6.26 6.54-10.85 22.17-13.89 32.55Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M444.1 307.8c-.86 1.39-2.4 3.9-4.22 6.88-4.4 7.17-10.45 17-12.54 20.32-4.37 6.84-7.62 17.87-8.37 27.53-1.05 13.53-.77 21.78-.55 35.41a4.35 4.35 0 0 1-2.92 1.74 6.93 6.93 0 0 1-2.18 0h-.05a5.89 5.89 0 0 1-4.13-2.49c-1.84-3-.39-7.81-1.06-11.85q-1.49-9-3-18.05c-1.21-7.3-2.43-14.75-2.16-22.29a83.76 83.76 0 0 1 3.76-20.61c3-10.36 7.63-26 13.87-32.56 6-6.31 23.84-10.1 25.25 2.63.74 6.54 1.2 8.63-1.7 13.34Z",
    transform: "translate(-.37 -57)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M439.88 314.68c-4.4 7.17-10.45 17-12.54 20.32-4.37 6.84-7.62 17.87-8.37 27.53-1.05 13.53-.77 21.78-.55 35.41a4.35 4.35 0 0 1-2.92 1.74h-2.23v-48.36c0-15.77 17.33-43 17.33-43 3.4-3.66 6.9 1.31 9.28 6.36Z",
    transform: "translate(-.37 -57)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M452.46 320.73c2.44 6.58 4.54 13.53 8.47 17.91 2.52 2.82 3.16 4.14 8.81-2.42 2.75-3.19.5-6.77-.88-11.05-6.81-21.18-3.62-46.5-3.49-70.28.11-19.11-31.78-34.27-33.06-17.56-3.42 44.6 13.64 65.82 20.15 83.4Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M469.43 394c-3.05 2.89-4.7 5.55-7.22 2.74-3.93-4.39-6.94-12.44-9.38-19-6.51-17.58-22.23-40.86-20.15-83.4.73-15 26.78-4.37 32.11 11.75a18.14 18.14 0 0 1 .95 5.81c-.13 23.78-3.32 49.1 3.49 70.28 1.38 4.27 3.27 8.94.2 11.82Z",
    transform: "translate(-.37 -57)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#25233a",
    d: "M416.05 67.38c6.85.3 12.92 4.37 18.2 8.73a10.51 10.51 0 0 0 2.69 1.81c1.26.5 1.51 1.06 2.85 1.23 5 .67 10.37 3.77 12.75 8.21s3.18 9.56 3.54 14.58c.32 4.58.42 9.51 3.13 13.21 4.2 5.73 12.56 6 18.7 9.58a20 20 0 0 1 9.1 12.14c1.08 4.14.88 8.49 1.44 12.73s2.14 8.68 5.7 11c-6.81-.09-16.62 5.1-23.44 5-2.44 0-1.93-5.37-4.27-6a22.3 22.3 0 0 1-6.81-3.6 58.78 58.78 0 0 1-21-28.25c-1.54-4.47-17.46 18.11-19.32 13.76-10-23.45 9-35.16 4.33-36.13-3.86-.81-7.85.47-11.8.28-23.06-1.09-18.14-39.26 4.21-38.28Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M389.07 152.77c-4.94 0-9.82-1-14.64-2.07L357.3 147a5.11 5.11 0 0 0-2.48-.12 4 4 0 0 0-2.13 1.91c-2.9 4.87-.54 11.51 3.81 15.14s10.11 5 15.67 6.08c7.42 1.47 15.1 2.72 22.51 1.18 9.15-1.91 22.05-4.57 29.22-10.56.94-.78-3.28-4.86-2.73-5.94a9.21 9.21 0 0 0 .7-4c.06-2.91 10.5-22.68 7.3-24.23-3-1.47-14.81 15.27-16.8 17.09a35.1 35.1 0 0 1-23.3 9.22Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M423.22 215c.8 1.16 1.49 2.25 1 2.61-7.17 6-20.07 8.65-29.22 10.56-7.41 1.54-15.09.29-22.51-1.18-5.56-1.1-11.33-2.44-15.67-6.08a14.25 14.25 0 0 1-2.12-2.2.59.59 0 0 1-.07-.1c-2.85-3.73-4-8.87-1.62-12.84a4 4 0 0 1 2.13-1.91 5.11 5.11 0 0 1 2.48.12l17.13 3.69c4.82 1 9.7 2.09 14.64 2.07a35.1 35.1 0 0 0 23.3-9.22c2-1.82 13.76-18.56 16.8-17.09 3.2 1.55-7.24 21.32-7.3 24.23a9.21 9.21 0 0 1-.7 4c-.29.57.76 2 1.67 3.31Z",
    transform: "translate(-.37 -57)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M353.06 205.8s1-2.16 2.13-1.91 4.38 10.11-.51 14.75c0 0-3.84-8.08-1.62-12.84Z",
    transform: "translate(-.37 -57)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M424.27 217.64c-7.17 6-20.07 8.65-29.22 10.56-7.41 1.54-15.09.29-22.51-1.18-5.56-1.1-11.33-2.44-15.67-6.08a14.25 14.25 0 0 1-2.12-2.2.59.59 0 0 1-.07-.1l.44-7.87c.57.51 3.64 2 17.41 6.11 20.13 6.05 45.19-7.18 45.19-7.18l5.49 5.31c.79 1.18 1.5 2.27 1.06 2.63Z",
    opacity: 0.17,
    transform: "translate(-.37 -57)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M478.47 247.87a4.26 4.26 0 0 1-1.33 2.86 4.4 4.4 0 0 1-3 .51c-2.8-.21-6-.34-9.27-.7a45 45 0 0 1-10.14-2.16c-11.5-4.11-22.09-11.43-25.91-13-2.74-1.09-13.84 1.79-15.9-.33-4.9-5 4.05-12.73 5.58-19.58 2.67-12 8.41-24 5.86-36a83.31 83.31 0 0 0-3-9.43c-2.48-7.33-5.51-17.57-3.19-25.26 1.81-6 4.71-14.65 9.66-18.74 5.7-4.7 7.69-2.53 15.07-2.33 5.15.14 19.22 5.85 20.77 8.07 16.09 23.22 12.62 67.77 15.16 101.55a60.44 60.44 0 0 1-.36 14.54Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M478.84 304.87a4.32 4.32 0 0 1-1.32 2.86c-.85.63-4.41-5-5.46-5.12-6.53-.49-10.59 4.18-17 2.77-.57-1.34-.19-2.67 1.57-4 9.1-6.61 5.82-74.37 3.42-92.82 5.52 1.9 3-21.15 3.94-19.75 16.09 23.21 12.62 67.75 15.16 101.54a59.94 59.94 0 0 1-.31 14.52Z",
    transform: "translate(-.37 -57)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M456.65 301.42c-1.76 1.29-2.14 2.62-1.57 4-8.77-1.93-17.69-9.36-25.91-13-2.71-1.18-13.84 1.79-15.9-.33-4.9-5 4.05-12.73 5.58-19.58 2.67-12 8.41-24 5.86-36a85.89 85.89 0 0 0-3-9.42c-2.48-7.33-5.51-17.57-3.2-25.26 1.82-6 4.72-14.65 9.67-18.74 5.7-4.7 7.69-2.53 15.07-2.33 1.92 0 17.47 6.94 20.77 8.07 2.39 18.47 1.73 105.98-7.37 112.59Z",
    transform: "translate(-.37 -57)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M425.9 230.79s3 13.82.49 22.83-9.22 37.69-9.23 38.47 4.36 1.23 4.36 1.23l23.37-16.47 7.14 7s15.11-10.47 25.77-26.21l-.35-9.15-50.11 27.24a22 22 0 0 0 2-7.75c.49-4.79 3.33-27.37-3.44-37.19Z",
    opacity: 0.17,
    transform: "translate(-.37 -57)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "m422.1 147.35-3.49 6.16 6.92 20.28 1.44-.46-.78-21.25-4.09-4.73z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "m422.1 147.35-3.49 6.16 6.92 20.28 1.44-.46-.78-21.25-4.09-4.73z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#25233a",
    d: "M426.22 148.12c-.15 8-.53 21.89.43 20.7 3.44-4.24 20.33-44.89 14.8-45.72-6.65-1-14.69-2.84-15.23 25.02Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M441.78 181.08s-5.42 7.39-9.86 10.27a1.44 1.44 0 0 1-2.21-1.38 17.81 17.81 0 0 0 0-4.79 7.13 7.13 0 0 0-1.34-3.35 4.31 4.31 0 0 0-1.29-1.1c-4.53-2.53 5-21.69 9.4-16.21Z",
    transform: "translate(-.37 -57)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#25233a",
    d: "M395.5 88.93c-1.74 5.36-.67 12.2 4.17 15.08 2.57 1.53 5.86 1.79 8 3.84 3.67-4.6 11.47-4.26 14.8-9.1a9.26 9.26 0 0 0 1.11-7.38 16.26 16.26 0 0 0-3.71-6.64 19 19 0 0 0-8.1-5.73c-8.08-2.71-13.77 2.28-16.27 9.93Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M404.22 152.84c-.33.95 8.45 31.85 22.87 27.89 6.59-1.81 7.61-9.1 8-15a65.1 65.1 0 0 0-.43-12.79s-21.13-27.44-30.44-.1Z",
    transform: "translate(-.37 -57)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#25233a",
    d: "M450.84 111.4a4 4 0 0 1-2.31 2.14 8.52 8.52 0 0 1-3.18.46 6.79 6.79 0 0 1-2.8-.5 8.2 8.2 0 0 1-2.17-1.72c.32.43-1.49-1.19-5.78-4.56 0-3.58 1.79-11.26-2-10.24-1.48.4-1.5 4.4-1.65 4.68.17-.9-1.06-3.11-1.62-4.75-3.12.14-6.43.74-10.75-4.78-7.05-9-14.61-8.33-14.61-8.33 4.49-2.94 10.32-9.61 22.44-7.74 5.4.84 7.66 5.24 8.47 9.86a27.63 27.63 0 0 1 4 2.44c4.25 3.23 6.73 8.28 8.3 13.38.65 2.11 1.18 4.26 1.95 6.32a14.73 14.73 0 0 0 1.71 3.34Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M330.33 205.6c1.17 2 8.12 1.71 9.76 2.58-.54 0-7.34-.3-9.11-.26-1.3 0-1.29 1.53-.33 2 2.32 1.18 7.71.82 9.56 1.36-.8-.3-7.47.42-8.32.49-1.15.2-2.37 1.94 1.37 2.29 1.52.14 5.23 0 7.07.4 1 .19-6.21.53-6.33 1.56-.25 2.08 7.18 1.55 7.74 1.6 3.5.33 10.27 1.25 12.94 1 0-2.8 1.81-6.57-.58-11-.36-.67-4.13-2.8-4.52-3.42-1.81-2.84-4-5.06-6.19-5.56-3.65-.82-.43 2.24-.29 4.71.19 3.14-.55 2.23-5 1.41-.93-.15-8.91-1.06-7.77.84Z",
    transform: "translate(-.37 -57)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M432.58 264.83a20.82 20.82 0 0 0-8.11.95.69.69 0 0 0-.39.24.6.6 0 0 0-.06.37 2.43 2.43 0 0 0 2.25 1.82 20.37 20.37 0 0 0 3.11-.19c.52 0 1.2.17 1.21.7a1 1 0 0 1-.15.46 6 6 0 0 1-3.56 2.32 29.24 29.24 0 0 1-8.75 1.37 20.52 20.52 0 0 0-3.92.17c-.41.08-.88.27-.94.69a1 1 0 0 0 .45.8c1.84 1.54 4.47 1.56 6.87 1.49l-4.89.41a3.72 3.72 0 0 0-2.29.7 3.2 3.2 0 0 0 2 1.55 9.69 9.69 0 0 0 2.59.32l3.94.09a13 13 0 0 0-5.41 1 .71.71 0 0 0-.35.24c-.18.31.17.67.49.84 2.74 1.44 6 1.07 9.09.66l-4.58 1.07c-.21.05-.46.15-.47.36a.35.35 0 0 0 .12.25 1.48 1.48 0 0 0 1.07.35 24 24 0 0 0 9.76-1.12 30.76 30.76 0 0 0 4.06-1.93 12.59 12.59 0 0 0 2-1.23 11.07 11.07 0 0 0 1.66-1.83c1.17-1.51 7.14-3.93 8.17-5.53a1.49 1.49 0 0 0 .27-.62c0-.43.3-1.72 0-2-1.06-1-2.5-1.06-3-2.42-.24-.6-3.1-1.77-3.35-2.36-.35-.81-3 .41-3.82.46a34.83 34.83 0 0 1-5.07-.45Z",
    transform: "translate(-.37 -57)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "m449.44 220.77-14.19-16.32s27.73-16 26.59-26.43-12.24-22.84-13.65-33 15.44-13.18 15.44-13.18c11.42 12.24 13.85 33.37 19 50.32 4.55 14.74-33.19 38.61-33.19 38.61Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "m449.81 277.77-8-9.24-6.16-7.08s27.73-16 26.59-26.43a21.61 21.61 0 0 0-.93-4.23c-3-9.45-11.5-19.95-12.72-28.74-1.44-10.12 15.41-13.21 15.41-13.21 11.42 12.24 13.85 33.37 19 50.32 4.55 14.74-33.19 38.61-33.19 38.61Z",
    transform: "translate(-.37 -57)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "m442.96 143 2.49 8.84s-14.82 19.01-18.48 21.49.59-5.91.59-5.91 8.77-17.33 9.44-22.24 5.96-2.18 5.96-2.18Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "m443.33 200 2.49 8.84s-14.82 19.01-18.48 21.49.59-5.91.59-5.91 8.77-17.33 9.44-22.24 5.96-2.18 5.96-2.18Z",
    transform: "translate(-.37 -57)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M440.39 120.88s3.53.83 5.06 2.22 4.18 13.64 4.18 13.64l-14.23 13.32s5.92-23.37 4.99-29.18Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M440.76 177.88s3.53.83 5.06 2.22 4.18 13.64 4.18 13.64l-14.23 13.32s5.92-23.37 4.99-29.18Z",
    transform: "translate(-.37 -57)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M429.35 128.18c-3.31 7.47-3.33 25.32-3.33 25.32l-8.11-12.72 10.1-15.95a7.13 7.13 0 0 1 1.34 3.35Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M429.72 185.18c-3.31 7.47-3.33 25.32-3.33 25.32l-8.11-12.72 10.1-15.95a7.13 7.13 0 0 1 1.34 3.35Z",
    transform: "translate(-.37 -57)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M469.43 394s-6.94-18.47-9.91-32.36-4.44-56.27-4.44-56.27a45 45 0 0 0 10.14 2.16 18.11 18.11 0 0 1 .52 4.35c-.13 23.78-3.32 49.1 3.49 70.28 1.38 4.29 3.27 8.96.2 11.84Z",
    transform: "translate(-.37 -57)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M355.13 210.5v.27c-.27-.24 0-.27 0-.27Z",
    transform: "translate(-.37 -57)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M102.77 195.57v195.05C102.77 407.39 91 421 76.45 421s-26.32-13.6-26.32-30.37v-195Z",
    transform: "translate(-.37 -57)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M117.31 134.88a8.57 8.57 0 0 1-8.58 8.58H42.11a8.59 8.59 0 1 1 0-17.17h66.62a8.58 8.58 0 0 1 8.58 8.59Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "M117.68 191.88a8.57 8.57 0 0 1-8.58 8.58H42.48a8.59 8.59 0 1 1 0-17.17h66.62a8.58 8.58 0 0 1 8.58 8.59Z",
    transform: "translate(-.37 -57)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M238.07 125.43v99.35a7 7 0 0 1-.4 2.36c-1.38 3.92-7.56 14.06-20.7 21.39-31.16 17.38-41.32 60.9-42.44 62.19-3.9 4.49-13.33 12.73-23.63 2.45-13.52-13.47 15.33-52.59 24.56-62.23 13-13.56 40.38-17.31 40.76-30.07.31-10.56.11-73.82 0-95.42a7.19 7.19 0 0 1 7.2-7.22h7.41a7.2 7.2 0 0 1 7.24 7.2Z",
    transform: "translate(-.37 -57)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 163.13,
    cy: 289.26,
    r: 16.14,
    fill: "url(#I)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "M467.14 248.53c-2.39 6.74-25.36 20-25.36 20l-6.16-7.08s27.73-16 26.59-26.43a21.61 21.61 0 0 0-.93-4.23s8.25 11 5.86 17.74Z",
    transform: "translate(-.37 -57)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "M431.59 160.18s2 .17 1.44-1.45-.07-3.76 1.06-3.59.35 6.39-.41 6.87-2.09-1.83-2.09-1.83Z",
    transform: "translate(-.37 -57)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 195.8,
    cy: 15.02,
    r: 15.02,
    fill: "#68e1fd",
    opacity: 0.25,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.4,
    cy: 69.11,
    r: 11.26,
    fill: "#68e1fd",
    opacity: 0.25,
    style: {
      isolation: "isolate"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacy);
export default __webpack_public_path__ + "static/media/pharmacy.11f86a8fb1c58ac5c3607477a76fc301.svg";
export { ForwardRef as ReactComponent };